module.exports = __webpack_public_path__ + "static/media/linkedin.a0180e32.svg";